import Base from './Base';


export default class MyReservationModel extends Base  {
	public reservation_id: number;
	public status:number;
	
	public name: string;
	public totalReservations:number;
	
	constructor() {
		super(null);
		this.reservation_id = 0;
		this.status = 0;
		this.name = "";
	}

	protected serialize() {
		const str = JSON.stringify(this);
		return str;
	}
	
	public createNewInstance() {
		return new MyReservationModel();
	}
}